const OnlineAttendanceRoutes = [
    {
        name: 'OnlineAttendance',
        path: '/timeattendance/online-attendance',
        component: () => import('@/views/TimeAttendance/OnlineAttendance/OnlineAttendance.vue'),
    },
    {
        name: 'OnlineAttendanceReport',
        path: '/OnlineAttendance/OnlineAttendanceReport',
        component: () => import('@/views/TimeAttendance/OnlineAttendance/OnlineAttendanceReportView.vue'),
    },
    {
        path: '/onlineattendance/record',
        name: 'onlineattendance-record',
        component: () => import('@/views/TimeAttendance/OnlineAttendance/OnlineAttendanceRecordView.vue'),
    },
    {
        path: '/OnlineAttendance/WorkingLocation',
        component: () => import('@/views/TimeAttendance/OnlineAttendance/WorkingLocationView.vue'),
    },
    {
        path: '/onlineAttendance/SetWorkingLocation',
        component: () => import('@/views/TimeAttendance/OnlineAttendance/SetWorkingLocationView.vue'),
    },
]

export default OnlineAttendanceRoutes
